import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';



// // ⚠️ DEV ONLY — REMOVE BEFORE COMMIT
const RealDate = Date;

// (window as any).Date = class extends RealDate {
//   constructor(...args: any[]) {
//     if (args.length === 0) {
//       // mock "now"
//       super('2026-04-30T00:00:00');
//     } else {
//       super(...(args as ConstructorParameters<typeof RealDate>));
//     }
//   }
// };

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


// In main.ts or app.component.ts
window.addEventListener('beforeunload', () => {
  const currentRoute = window.location.pathname + window.location.search;
  localStorage.setItem('lastRoute', currentRoute);
});

